import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  dashboardJefeObjetivos: [],
  dashboardJefeObjetivosError: "",
};

export default function DashboardJefeObjetivosReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_DASHBOARD_JEFE_OBJETIVOS:
      return { ...state, loading: action.payload };
    case actions.GET_DASHBOARD_JEFE_OBJETIVOS:
      return { ...state, dashboardJefeObjetivos: action.payload };
    case actions.DASHBOARD_JEFE_OBJETIVOS_FAIL:
      return { ...state, dashboardJefeObjetivosError: action.payload };
    default:
      return state;
  }
}
